export default {"src":"/_next/static/media/logo.2d04e508.svg","height":56,"width":275,"blurWidth":0,"blurHeight":0};